import React from "react";
import { Building2, User, MapPin, Phone, Mail, Globe } from "lucide-react";
import Seo from "../components/Seo";
import { useLang } from "../context/LanguageContext";

const Block = ({ icon: Icon, label, children, testid }) => (
  <div data-testid={testid} className="flex items-start gap-4 py-5 border-b border-slate-100 last:border-0">
    <span className="w-10 h-10 rounded-xl bg-teal-50 flex items-center justify-center shrink-0"><Icon className="w-5 h-5 text-teal-700" /></span>
    <div>
      <div className="text-xs text-slate-500 uppercase tracking-wide mb-1">{label}</div>
      <div className="text-slate-900 leading-relaxed">{children}</div>
    </div>
  </div>
);

export default function Impressum() {
  const { lang } = useLang();
  const de = lang === "de";
  return (
    <div>
      <Seo pageKey="impressum" title={de ? "Impressum | MyCleaner.ch" : "Legal notice | MyCleaner.ch"}
        description={de ? "Impressum von MyCleaner Hofer, Reinigungsdienstleistungen, Kirchweg 25, 5313 Klingnau." : "Legal notice of MyCleaner Hofer, cleaning services, Kirchweg 25, 5313 Klingnau, Switzerland."} />
      <section className="pt-[116px] pb-10 bg-gradient-to-b from-amber-50 to-white">
        <div className="max-w-[720px] mx-auto px-5 md:px-6">
          <h1 className="font-head font-extrabold text-4xl sm:text-5xl text-slate-900 mb-3">{de ? "Impressum" : "Legal notice"}</h1>
          <p className="text-slate-600">{de ? "Angaben gemäss schweizerischem Recht" : "Information in accordance with Swiss law"}</p>
        </div>
      </section>
      <section className="pb-20">
        <div data-testid="impressum-card" className="max-w-[720px] mx-auto px-5 md:px-6">
          <div className="bg-white rounded-2xl border border-slate-100 px-6 py-2">
            <Block icon={Building2} label={de ? "Unternehmen" : "Company"} testid="impressum-company">
              <div className="font-head font-semibold">MyCleaner Hofer</div>
              <div className="text-slate-600">{de ? "Reinigungsdienstleistungen" : "Cleaning services"}</div>
            </Block>
            <Block icon={User} label={de ? "Inhaberin" : "Owner"} testid="impressum-owner">Renata Hofer</Block>
            <Block icon={MapPin} label={de ? "Geschäftsadresse" : "Business address"} testid="impressum-address">
              Kirchweg 25<br />5313 Klingnau<br />{de ? "Schweiz" : "Switzerland"}
            </Block>
            <Block icon={Phone} label={de ? "Telefon" : "Phone"} testid="impressum-phone">
              <a href="tel:+41446880380" className="hover:text-teal-700">044 688 03 80</a>
            </Block>
            <Block icon={Mail} label="E-Mail" testid="impressum-email">
              <a href="mailto:info@mycleaner.ch" className="hover:text-teal-700">info@mycleaner.ch</a>
            </Block>
            <Block icon={Globe} label="Website" testid="impressum-website">
              <a href="https://www.mycleaner.ch" className="hover:text-teal-700">www.mycleaner.ch</a>
            </Block>
          </div>
        </div>
      </section>
    </div>
  );
}
